package com.yogaaicoach.pages.auth

/**
 * Should only be created through TokenDataManager
 * TODO constructor should be private, but we cannot make it private with data class
 */
data class TokenData constructor(
    // The access token used to call APIs
    var accessToken: String,

    // The refresh token used to renew access tokens
    var refreshToken: String,

    // The id token as proof of authentication, also used for logout
    var idToken: String,

    var expirationTimestampMs: Long,

    var isSubscribed: Boolean? = null,

    var freeTrialDaysLeft: Int? = null
) {
    companion object {
        internal fun create(
            accessToken: String,
            refreshToken: String,
            idToken: String,
            expirationTimestampMs: Long,
            isSubscribed: Boolean? = null,
            freeTrialDaysLeft: Int? = null
        ): TokenData {
            return TokenData(accessToken, refreshToken, idToken, expirationTimestampMs, isSubscribed, freeTrialDaysLeft)
        }
    }
}